/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventTimeType = "Date" | "DateTime" | "%future added value";
export type SuggestionBodyExpensiveMeeting_suggestionPayload = {
    readonly focusMinutesCost?: number | null | undefined;
    readonly targetEvent?: {
        readonly title: string | null;
        readonly calendarIds: ReadonlyArray<string>;
        readonly organizer: {
            readonly urnValue: string;
        } | null;
        readonly createdMillis: unknown | null;
        readonly startTime: {
            readonly type: EventTimeType;
            readonly dateOrDateTime: string;
            readonly timeZone: string | null;
            readonly millis: number;
            readonly offsetMinutes: number | null;
        };
        readonly endTime: {
            readonly type: EventTimeType;
            readonly dateOrDateTime: string;
            readonly timeZone: string | null;
            readonly millis: number;
            readonly offsetMinutes: number | null;
        };
    } | null | undefined;
    readonly " $refType": "SuggestionBodyExpensiveMeeting_suggestionPayload";
};
export type SuggestionBodyExpensiveMeeting_suggestionPayload$data = SuggestionBodyExpensiveMeeting_suggestionPayload;
export type SuggestionBodyExpensiveMeeting_suggestionPayload$key = {
    readonly " $data"?: SuggestionBodyExpensiveMeeting_suggestionPayload$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionBodyExpensiveMeeting_suggestionPayload">;
};



const node: ReaderFragment = (function () {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOrDateTime",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeZone",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "millis",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offsetMinutes",
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "SuggestionBodyExpensiveMeeting_suggestionPayload",
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "focusMinutesCost",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "targetEvent",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "calendarIds",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Attendee",
                                "kind": "LinkedField",
                                "name": "organizer",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "urnValue",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "createdMillis",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventTime",
                                "kind": "LinkedField",
                                "name": "startTime",
                                "plural": false,
                                "selections": (v0 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventTime",
                                "kind": "LinkedField",
                                "name": "endTime",
                                "plural": false,
                                "selections": (v0 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "type": "SuggestionResultExpensiveMeetingPayload",
                "abstractKey": null
            }
        ],
        "type": "SuggestionResultPayload",
        "abstractKey": "__isSuggestionResultPayload"
    } as any;
})();
(node as any).hash = '1dcc133b996940897a4d4e4d3715e339';
export default node;
